<!-- Right Sidebar -->
<div class="right-bar" (clickOutside)="hide()" [excludeBeforeClick]="true" [exclude]="'.right-bar-toggle'">
  <div class="rightbar-title">
    <a href="javascript:void(0);" class="right-bar-toggle float-right" (click)="hide();">
      <i data-feather="x-circle" appFeatherIcon></i>
    </a>
    <h5 class="m-0">Customization</h5>
  </div>

  <div class="slimscroll-menu" appSlimScroll>

    <h5 class="font-size-16 pl-3 mt-4">Choose Variation</h5>
    <div class="p-3">
      <h6>Default</h6>
      <button class="btn btn-link p-0" (click)="changeLayout('vertical')"><img src="assets/images/layouts/vertical.jpg"
          alt="vertical" class="img-thumbnail demo-img" /></button>
    </div>
    <div class="px-3 py-1">
      <h6>Top Nav</h6>
      <button class="btn btn-link p-0" (click)="changeLayout('horizontal')"><img
          src="assets/images/layouts/horizontal.jpg" alt="horizontal" class="img-thumbnail demo-img" /></button>
    </div>
    <div class="px-3 py-1">
      <h6>Dark Side Nav</h6>
      <button class="btn btn-link p-0" (click)="changeLeftSidebarTheme('dark')"><img
          src="assets/images/layouts/vertical-dark-sidebar.jpg" alt="dark sidenav"
          class="img-thumbnail demo-img" /></button>
    </div>

    <div class="px-3 py-1">
      <h6>Condensed Side Nav</h6>
      <button class="btn btn-link p-0" (click)="changeLeftSidebarType('condensed')"><img
          src="assets/images/layouts/vertical-condensed.jpg" alt="condensed" class="img-thumbnail demo-img" /></button>
    </div>

    <div class="px-3 py-1">
      <h6>Fixed Width (Boxed)</h6>
      <button class="btn btn-link p-0" (click)="changeLayoutWidth('boxed')"><img
          src="assets/images/layouts/boxed.jpg" alt="boxed" class="img-thumbnail demo-img" /></button>
    </div>

    <div class="my-5">&nbsp;</div>
  </div> <!-- end slimscroll-menu-->
</div>
<!-- /Right-bar -->

<!-- Right bar overlay-->
<div class="rightbar-overlay"></div>
